import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'

interface UseDeletePublicCompanyLeadContactProps {
  contactId?: string
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

export const useDeletePublicCompanyLeadContact = ({
  contactId,
  onSuccess,
  onError,
}: UseDeletePublicCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deletePublicCompanyLeadContact'],
    mutationFn: async () => {
      await privateAxios.delete(`/funnel/contacts/${contactId}`)
    },
    onSuccess,
    onError,
  })
}
